export default __webpack_public_path__ + "static/media/instr02.e2afa59a.svg";